<template>
  <div class="account-pages my-5 pt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center mb-5">
            <h1 class="display-2 fw-medium">
              4<i class="bx bx-buoy bx-spin text-primary display-3"></i>4
            </h1>
            <h4 class="text-uppercase">{{$t('error_pages.not_found.sorry')}}</h4>
            <div class="mt-5 text-center">
              <router-link tag="a" class="btn btn-primary" to="/">{{$t('error_pages.not_found.back')}}</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/error-img.png" alt class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "NotFound",
  page() {
    return {
      title: this.$t('error_pages.not_found.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
}
</script>

